import { ViewModel } from '../view-model';
import { RelationshipType } from './relationship-type';

export class RelatedItem implements ViewModel {
  friendlyTypeNameSingular: string = 'Related Item';
  apiRoute: string;

  linkedItemId: string;
  linkedItemType: string;
  linkedItemName: string;
  identifierName: string;
  linkedItemParentId: string;
  linkedItemParentType: string;
  relationshipType: RelationshipType;
  orgTreeNodeId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.linkedItemId = data.linkedItemId;
    this.linkedItemType = data.linkedItemType;
    this.linkedItemName = data.linkedItemName;
    this.identifierName = data.identifierName;
    this.linkedItemParentId = data.linkedItemParentId;
    this.linkedItemParentType = data.linkedItemParentType;
    this.relationshipType = data.relationshipType;
    this.orgTreeNodeId = data.orgTreeNodeId;
  }
}
